import API from '@aws-amplify/api';
import Constant from '@/common/constant/Constant';
import Logger from '@/common/utils/Logger';
import Utils from '@/common/utils/utils';
import { checkViewTicketPermission } from '@/graphql/queries';
import {
    getChatPostById,
    getChatPostListByChatThreadId,
    sortByCreatedAtAndSeqAsc,
    updateChatPostById
} from '@/service/chatPostService';
import { getTicketById } from '@/service/ticketService';
import { getUserById, getUserDeletedInfor } from '@/service/userService';
import { deleteAllTicketData } from '@/service/ticketService';
import _, { cloneDeep, some, every } from 'lodash';
import { openPanelByTicketDetail } from './DetailTicketHandler';
import { setRecoil } from 'recoil-nexus';
import { reloadTicketDetailIdAtom } from '@/state/atom/panelAtom';
import { I18n } from 'aws-amplify';

const SUBSCRIPTION_TYPE = Constant.SUBSCRIPTION_TYPE;

/**
 * Is show block msg
 * @param {*} msgBlockList
 * @param {*} stateDeleteList
 * @param {*} metaData
 * @returns isShow
 */
export const isShowBlockMsg = (msgBlockList, stateDeleteList, metaData) => {
    let isEmailTicket = Constant.TICKET_TYPE.EMAIL === metaData?.ticketInfo?.ticketType;

    // For email ticket only
    if (isEmailTicket) {
        if(some(msgBlockList, (data) => data.status !== Constant.CHAT_POST_STATUS.DELETE_READ)) {
            return true;
        }
        if(every(msgBlockList, (data) => data.status === Constant.CHAT_POST_STATUS.DELETE_READ)) {
            if(metaData?.userDetail?.id === msgBlockList[0].creatorId){
                return false;
            }
            return true;
        }
        return false;
    }

    let isShow = false;
    for (let i = 0; i < msgBlockList.length; i++) {
        if (stateDeleteList[msgBlockList[i].id] !== Constant.CHAT_POST_STATUS.DELETE_READ) {
            isShow = true;
            break;
        }
    }
    return isShow;
};

// export const isShowBlockMsg = (msgBlockList, stateDeleteList, metaData) => {
//     let isEmailTicket = Constant.TICKET_TYPE.EMAIL === metaData?.ticketInfo?.ticketType;
//     let isShow = true;
//     for (let i = 0; i < msgBlockList.length; i++) {
//         if (stateDeleteList[msgBlockList[i].id] === Constant.CHAT_POST_STATUS.DELETE_READ) {
//             if(isEmailTicket && msgBlockList[i].creatorId !== metaData?.userDetail?.id) {
//                 // Email ticket is show delete message if user login is not user delete message
//                 break;
//             }
//             isShow = false;
//             break;
//         }
//     }
//     return isShow;
// };

/**
 * Is show tmp delete msg
 * @param {*} isAlignLeft
 * @param {*} currentPost
 * @param {*} metaData
 * @returns isShow
 */
 export const isShowDeleteTmpMsgWithAlignRule = (isAlignLeft, currentPost, metaData) => {
    let isEmailTicket = Constant.TICKET_TYPE.EMAIL === metaData?.ticketInfo?.ticketType;
    let isShow = isAlignLeft;
    if (currentPost?.status === Constant.CHAT_POST_STATUS.DELETE_READ) {
        if(isEmailTicket && currentPost.creatorId !== metaData?.userDetail?.id) {
            // Email ticket is show delete message if user login is not user delete message
            isShow = true;
        }
    }
    return isShow;
};


export const isShowBlockMsgKnowLedge = (msgBlockList, stateDeleteList, userId) => {
    let isShow = false;
    const msgListStatus = [];
    for (let i = 0; i < msgBlockList.length; i++) {
        msgListStatus.push({
            msgId: msgBlockList[i].id,
            status: stateDeleteList[msgBlockList[i].id],
            creatorId: msgBlockList[i].creatorId,
        });
    }
    if(some(msgListStatus, (data) => data.status !== Constant.CHAT_POST_STATUS.DELETE_READ)) {
        return true;
    }
    if(every(msgListStatus, (data) => data.status === Constant.CHAT_POST_STATUS.DELETE_READ)) {
        if(userId === msgListStatus[0].creatorId){
            return false;
        }
        return true;
    }
    return isShow;
};

/**
 * Delete msg handler
 * @param {*} API
 * @param {*} msg
 * @param {*} setStatusDeleteMsgList
 * @param {*} statusDeleteMsgList
 * @param {*} chatPostAllList
 * @param {*} msgContentList
 * @param {*} setChatPostUpdate
 * @returns
 */
export const onSubmitDeleteMsg = async (
    API,
    msg,
    setStatusDeleteMsgList,
    statusDeleteMsgList,
    chatPostAllList,
    msgContentList,
    setChatPostUpdate,
    setOpenModalDeleteMsg,
    ticketInfo,
    selectThread
) => {
    let newList = { ...statusDeleteMsgList };

    let index = chatPostAllList.findIndex((element, i) => {
        return element.id === msg.id;
    });
    let msgRes = { ...chatPostAllList[index] };
    // set loading
    msgRes.isLoading = true;
    msgRes.subcriptionType = Constant.SUBSCRIPTION_TYPE.UPDATE;

    if (setOpenModalDeleteMsg && typeof setOpenModalDeleteMsg === 'function') {
        setOpenModalDeleteMsg({ isOpen: false, msg: null });
    }

    setChatPostUpdate(msgRes);

    // delete physical
    // if (Utils.isEmptyArray(msgRes.footprintListDetail)) {
    //     // call api delete msg
    //     deleteChatPostById(API, msg.id).then((data) => {
    //         // set loading
    //         msgRes.isLoading = false;
    //         msgRes.subcriptionType = Constant.SUBSCRIPTION_TYPE.DELETE;
    //         setChatPostUpdate({...msgRes});
    //     });
    //     // clear text
    //     msgContentList[msg.id] = '';
    //     newList[msg.id] = Constant.CHAT_POST_STATUS.DELETE;
    //     setStatusDeleteMsgList(newList);
    //     return;
    // }

    // update status msg to 4: delete
    let chatPostInput = {
        id: msg.id,
        status: Constant.CHAT_POST_STATUS.DELETE_READ
    };
    let resultUpdate = await updateChatPostById(API, chatPostInput);
    // update new data
    if (!Utils.isEmptyObject(resultUpdate)) {
        // Remove ticket if message in email ticket
        if(ticketInfo?.ticketType === Constant.TICKET_TYPE.EMAIL) {
            let removeOldTicket = await deleteAllTicketData(API, {
                ticketId: msg?.ticketId
            });

            if (selectThread?.threadType === Constant.THREAD_TYPE.CUSTOMER) {
                setRecoil(reloadTicketDetailIdAtom, `${ticketInfo?.id} ${Date.now().toString()}`);
            }
        }

        newList[msg.id] = Constant.CHAT_POST_STATUS.DELETE_READ;
        setStatusDeleteMsgList(newList);
        //
        resultUpdate.isLoading = false;
        resultUpdate.userDetailPostMsg = msgRes.userDetailPostMsg;
        resultUpdate.footprintListDetail = msgRes.footprintListDetail;
        resultUpdate.subcriptionType = Constant.SUBSCRIPTION_TYPE.UPDATE;
        setChatPostUpdate(resultUpdate);
    }
};

/**
 * Is delete msg
 * If status of msg is delete_red: 4, delete: 5 then return delete is true
 * @param {*} msg
 * @param {*} chatPostAllList
 * @returns statusDelete
 */
export const isDeleteMsg = (msg, chatPostAllList) => {
    let isDelete;
    let statusMsg;
    // find msg in chatPostAllList
    let index = chatPostAllList.findIndex((msgItem, i) => {
        return msgItem.id === msg.id;
    });
    statusMsg = chatPostAllList[index]?.status;
    isDelete =
        statusMsg === Constant.CHAT_POST_STATUS.DELETE_READ ||
        statusMsg === Constant.CHAT_POST_STATUS.DELETE
            ? true
            : false;
    return isDelete;
};


export const isUploadingFileMsg = (msg) => {
    return !!([Constant.POST_TYPE.FILE, Constant.POST_TYPE.IMAGE].includes(msg.postType) && !msg.id);
}

export const getMessageContent = (msgDetail, userChatList) => {
    let message = msgDetail ? msgDetail?.content : '';
    if (
        !Utils.isEmptyArray(msgDetail.mention) &&
        !Utils.isEmptyString(message) &&
        !Utils.isEmptyArray(userChatList)
    ) {
        msgDetail.mention?.forEach(id => {
            let displayName = '';
            if (id === Constant.CHAT_MENTION_ALL.id) {
                message = message?.replace(
                    new RegExp(`@\\[${id}]`, 'g'),
                    `@${Constant.CHAT_MENTION_ALL.name}`
                );
            } else {
                let userMention = userChatList.find(user => user.id === id);
                if (!Utils.isEmptyObject(userMention)) {
                    displayName = Utils.getFullNameOfUser(Constant.LANGUAGE_TYPE.JP, userMention);
                    message = message?.replace(new RegExp(`@\\[${id}]`, 'g'), `@${displayName}`);
                }
            }
        });
    }

    return message;
};

/**
 * Handle show history dialog
 * @param {*} API
 * @param {*} msg
 * @param {*} setIsOpenHistoryDialog
 * @param {*} setIsLoadingHistoryList
 * @param {*} setHistoryList
 * @param {*} setMsgEditSelected
 */
export const onOpenHistoryDialog = async (
    API,
    msg,
    setIsOpenHistoryDialog,
    setIsLoadingHistoryList,
    setHistoryList,
    setMsgEditSelected,
    userChatList
) => {
    setIsOpenHistoryDialog(true);
    setIsLoadingHistoryList(true);
    setMsgEditSelected(msg);
    let msgDetail = await getChatPostById(API, msg.id);

    let message = getMessageContent(msgDetail, userChatList);
    let listMsgHistory = msgDetail?.history;
    let lastHistory = listMsgHistory[listMsgHistory.length - 1];
    let isExistCurrentMsgInHistory = lastHistory?.content === message || false;

    let historyResList = [];
    msgDetail?.history?.forEach(history =>
        historyResList.push(
            <li>
                <p>{Utils.unEscapeHtml(Utils.cleanHtml(history.content))}</p>
                <p className="dateTime">
                    {Utils.getDateTimeByFormatJapanYYYY_MM_DDHHMM(history.updatedAt)}
                </p>
            </li>
        )
    );
    // push current msg to history
    if (!isExistCurrentMsgInHistory) {
        historyResList.push(
            <li>
                <p>{Utils.unEscapeHtml(Utils.cleanHtml(message))}</p>
                <p className="dateTime">
                    {Utils.getDateTimeByFormatJapanYYYY_MM_DDHHMM(msgDetail.updatedAt)}
                </p>
            </li>
        );
    }
    
    setHistoryList(historyResList.reverse());
    setIsLoadingHistoryList(false);
};

/**
 * Handle click show edit msg
 * @param {*} API
 * @param {*} msg
 * @param {*} setMsgEditSelected
 * @param {*} setIsShowModalEditMsg
 * @param {*} msgRefList
 * @param {*} chatPostAllList
 * @param {*} setChatPostUpdate
 */
export const onClickShowEditMsg = async (
    API,
    msg,
    setMsgEditSelected,
    setIsShowModalEditMsg,
    msgRefList,
    chatPostAllList,
    setChatPostUpdate
) => {
    // set loading
    let index = chatPostAllList.findIndex((element, i) => {
        return element.id === msg.id;
    });
    let msgRes = { ...chatPostAllList[index] };
    // set loading
    msgRes.isLoading = true;
    msgRes.subcriptionType = Constant.SUBSCRIPTION_TYPE.UPDATE;
    setChatPostUpdate(msgRes);

    let msgDetail = await getChatPostById(API, msg.id);
    if (!msgDetail) {
        return;
    }
    // // get user detail post msg
    // let userDetailPostMsg = await getUserById(API, msgDetail.creatorId);
    // userDetailPostMsg = !Utils.isEmptyObject(userDetailPostMsg) ? userDetailPostMsg : {};
    // userDetailPostMsg.avatar = getUserAvatarUrl(userDetailPostMsg?.image);
    msgDetail.userDetailPostMsg = msgRes.userDetailPostMsg;

    setIsShowModalEditMsg({ [msg.id]: true });
    // console.log('namnhdebug scroll 3 onClickShowEditMsg')
    msgRefList[msg.id].current.scrollIntoView({ behavior: 'smooth' });
    setMsgEditSelected(msgDetail);

    // set disable loading
    let msgUpdateStatusLoading = { ...chatPostAllList[index] };
    msgUpdateStatusLoading.isLoading = false;
    msgUpdateStatusLoading.subcriptionType = Constant.SUBSCRIPTION_TYPE.UPDATE;
    setChatPostUpdate(msgUpdateStatusLoading);
};

/**
 * Handle submit edit msg
 * @param {*} API
 * @param {*} formData
 * @param {*} setIsShowModalEditMsg
 * @param {*} msgContentList
 * @param {*} msgEditSelected
 * @param {*} setEditedMsgList
 * @param {*} setStatusDeleteMsgList
 * @param {*} statusDeleteMsgList
 * @param {*} chatPostAllList
 * @param {*} setChatPostUpdate
 * @returns
 */
export const onSubmitEditMsg = (
    API,
    formData,
    setIsShowModalEditMsg,
    msgContentList,
    msgEditSelected,
    setEditedMsgList,
    setStatusDeleteMsgList,
    statusDeleteMsgList,
    chatPostAllList,
    setChatPostUpdate,
    mentionsList,
    userChatList,
    ticketInfo,
    reloadTicketDetail = () => {},
    userDetail
) => {
    //  close edit form
    setIsShowModalEditMsg({ [msgEditSelected.id]: false });

    // check msg is null
    if (Utils.isEmptyString(formData.msg)) {
        // call api delete
        onSubmitDeleteMsg(
            API,
            msgEditSelected,
            setStatusDeleteMsgList,
            statusDeleteMsgList,
            chatPostAllList,
            msgContentList,
            setChatPostUpdate
        );
        return;
    }

    // update msg content data
    let index = chatPostAllList.findIndex((element, i) => {
        return element.id === msgEditSelected.id;
    });
    let msgDetail = { ...chatPostAllList[index] };
    if ((msgDetail.content || '').trim() === (formData.msg || '').trim()) {
        return;
    }

    msgDetail.isLoading = true;
    msgDetail.content = formData.msg;
    msgDetail.subcriptionType = Constant.SUBSCRIPTION_TYPE.UPDATE;
    msgDetail.mention = mentionsList;
    setChatPostUpdate(msgDetail);
    // msgEditSelected.content = formData.msg;
    // update msg
    msgContentList[msgEditSelected.id] = formData.msg;
    // update status edited of msg by user
    setEditedMsgList({ [msgEditSelected.id]: true });
    setIsShowModalEditMsg({ [msgEditSelected.id]: false });

    // call api update msg
    let historyList = Utils.isEmptyArray(msgEditSelected.history) ? [] : msgEditSelected.history;
    if(msgDetail?.deliverInfo?.status !== Constant.DELIVER_STATUS.UNDELIVER){
        if (Utils.isEmptyArray(historyList)) {
            let msgRoot = {
                content: getMessageContent(msgEditSelected, userChatList),
                updatedAt: msgEditSelected.createdAt
            };
            let msgEdit = {
                content: getMessageContent(msgDetail, userChatList),
                updatedAt: new Date(Date.now()).toISOString()
            };
            historyList = [msgRoot, msgEdit];
        } else {
            let history = {
                content: getMessageContent(msgDetail, userChatList),
                updatedAt: new Date(Date.now()).toISOString()
            };
            historyList.push(history);
        }
    }
    // check read msg
    mentionsList = !Utils.isEmptyArray(mentionsList) ? [...new Set(mentionsList)] : [];
    let chatPostInput = {
        id: msgEditSelected.id,
        content: formData.msg,
        history: historyList,
        mention: mentionsList,
        creatorId : userDetail.id,
        updatedAt: msgEditSelected.updatedAt,
    };

    //email chat post in customer thread, to update status file to update email body
    if (msgEditSelected?.deliverInfo?.status === Constant.DELIVER_STATUS.UNDELIVER)
        chatPostInput.status = Constant.CHAT_POST_STATUS.UN_READ;

    updateChatPostById(API, chatPostInput).then(msgEdited => {
        if (!Utils.isEmptyObject(msgEdited)) {
            msgEdited.footprintListDetail = msgDetail.footprintListDetail;
            msgEdited.userDetailPostMsg = userDetail;

            if (ticketInfo?.ticketType === Constant.TICKET_TYPE.EMAIL) {
                reloadTicketDetail()
            }

            msgEdited.isLoading = false;
            msgEdited.subcriptionType = Constant.SUBSCRIPTION_TYPE.UPDATE;
            setChatPostUpdate(msgEdited);
        }
    });
};

/**
 * Get status edited msg
 * @param {*} editedMsgList
 * @param {*} msg
 */
export const isEditedMsg = (editedMsgList, msg) => {
    let isEdited = false;
    if (Utils.isEmptyObject(editedMsgList[msg.id])) {
        isEdited = Utils.isEmptyArray(msg.history) ? false : true;
        return isEdited;
    }
    isEdited = editedMsgList[msg.id];
    return isEdited;
};

/**
 * Is show delete tmp msg
 * @param {*} msg
 * @param {*} statusDeleteMsgList
 * @param {*} chatPostAllList
 * @returns currentStatus
 */
export const isShowDeleteTmpMsg = (msg, statusDeleteMsgList, chatPostAllList) => {
    let isShow;

    // get status by delete status list in state
    if (!Utils.isEmptyString(statusDeleteMsgList[msg.id])) {
        isShow =
            statusDeleteMsgList[msg.id] === Constant.CHAT_POST_STATUS.DELETE_READ ? true : false;
        return isShow;
    }

    // find msg in chatPostAllList
    let index = chatPostAllList.findIndex((msgItem, i) => {
        return msgItem.id === msg.id;
    });
    isShow =
        chatPostAllList[index]?.status === Constant.CHAT_POST_STATUS.DELETE_READ ? true : false;
    return isShow;
};

/**
 * Get content of msg
 * @param {*} msg
 * @param {*} statusDeleteMsgList
 * @param {*} chatPostAllList
 * @returns contentMsg
 */
export const getContentMsg = (msg, msgContentList, chatPostAllList) => {
    let msgContent;

    // get status by delete status list in state
    if (!Utils.isEmptyString(msgContentList[msg.id])) {
        msgContent = msgContentList[msg.id];
    } else {
        // find msg in chatPostAllList
        let index = chatPostAllList.findIndex((msgItem, i) => {
            return msgItem.id === msg.id;
        });
        msgContent = chatPostAllList[index].content;
    }
    return msgContent;
};

/**
 * Is loading msg handler
 * @param {*} msg
 * @returns isLoading
 */
export const isLoadingMsgHandler = msg => {
    return Utils.isEmptyObject(msg) || Utils.isEmpty(msg.isLoading) ? false : msg.isLoading;
};

/**
 * Handle observer last msg
 * @param {*} mutationsList
 * @param {*} observer
 * @param {*} idDivChatContentList
 * @param {*} isCreateNewMsg
 * @param {*} setIsCreateNewMsg
 */
const autoScrollLastMsg = (
    mutationsList,
    observer,
    idDivChatContentList,
    isCreateNewMsg,
    setIsCreateNewMsg
) => {
    // Callback function to execute when mutations are observed
    if (isCreateNewMsg) {
        let divLastMsg = document.getElementById(idDivChatContentList);
        // auto scroll to last msg
        if (divLastMsg) {
            divLastMsg.scrollTop = divLastMsg.scrollHeight;
        }
        // set is create new msg
        setIsCreateNewMsg(false);
    }
};

/**
 * Init observer last msg
 * @param {*} panelId
 * @param {*} chatThreadId
 * @param {*} isCreateNewMsg
 * @param {*} setIsCreateNewMsg
 * @returns observerLastMsg
 */
export const initObserverLastMsg = (panelId, chatThreadId, isCreateNewMsg, setIsCreateNewMsg) => {
    // config auto scroll last msg
    const idDivChatContentList = `divChatContentList-${panelId}-${chatThreadId}`;
    let targetNode = document.getElementById(idDivChatContentList);
    let config = { attributes: true, childList: true, subtree: true };

    // create observer
    let observerLastMsg = new MutationObserver((mutationsList, observer) =>
        autoScrollLastMsg(
            mutationsList,
            observer,
            idDivChatContentList,
            isCreateNewMsg,
            setIsCreateNewMsg
        )
    );
    observerLastMsg.observe(targetNode, config);

    return observerLastMsg;
};

/**
 *
 * @param {*} allState
 * @param {*} msgRes
 * @returns
 */
export const updateChatPostBySubsciptionResponse = async (allState, msgRes) => {
    let index = allState.chatPostAllList.findIndex((element, i) => {
        return element.id === msgRes.id;
    });

    if (index === undefined || index === null || index < 0) {
        return;
    };

    if (
        msgRes.creatorId !== allState.chatPostAllList[index]?.userDetailPostMsg?.id
    ) {
            const userDetailPostMsg = await getUserById(API,msgRes.creatorId);
            msgRes.userDetailPostMsg = userDetailPostMsg
    } else {
        // get user detail post msg
        msgRes.userDetailPostMsg = allState.chatPostAllList[index].userDetailPostMsg;
    }
  
    // event update msg
    if (msgRes.content != allState.msgContentList[msgRes.id]) {
        allState.msgContentList[msgRes.id] = msgRes.content;
        let msgContentNewList = { ...allState.msgContentList };
        allState.setMsgContentList(msgContentNewList);
    }
    // event update text edited
    if (!Utils.isEmptyArray(msgRes.history)) {
        allState.editedMsgList[msgRes.id] = true;
        let editedMsgNewList = { ...allState.editedMsgList };
        allState.setEditedMsgList(editedMsgNewList);
    }
    // event delete msg
    if (allState.statusDeleteMsgList[msgRes.id] != msgRes.status) {
        allState.statusDeleteMsgList[msgRes.id] = msgRes.status;
        let statusDeleteMsgNewList = { ...allState.statusDeleteMsgList };
        allState.setStatusDeleteMsgList(statusDeleteMsgNewList);
    }
    msgRes.subcriptionType = SUBSCRIPTION_TYPE.UPDATE;
    msgRes.footprintListDetail = allState.chatPostAllList[index].footprintListDetail
        ? allState.chatPostAllList[index].footprintListDetail
        : [];
    allState.setChatPostUpdate(msgRes);
    // event footprint
    if (msgRes.status !== Constant.CHAT_POST_STATUS.DELETE_READ) {
        updateFootprintDetailList(
            allState.API,
            msgRes,
            allState.userChatList,
            allState.setUserChatList
        )
            .then(() => {
                let numberFootprint = Utils.isEmptyArray(msgRes.footprintListDetail)
                    ? 0
                    : msgRes.footprintListDetail.length;
                if (allState.footprintDetailList[msgRes.id] !== numberFootprint) {
                    allState.footprintDetailList[msgRes.id] = numberFootprint;
                    let footprintDetailNewList = { ...allState.footprintDetailList };
                    allState.setFootprintDetailList(footprintDetailNewList);
                    Logger.info(
                        'updateChatPostBySubsciptionResponse >>> footprintDetailNewList',
                        footprintDetailNewList
                    );
                }
                Logger.info('updateChatPostBySubsciptionResponse >>> new msgRes ', msgRes);

                msgRes.subcriptionType = SUBSCRIPTION_TYPE.UPDATE;
                allState.setChatPostUpdate(msgRes);
            })
            .catch(err => {
                Logger.info(
                    'updateChatPostBySubsciptionResponse >>> updateFootprintDetailList >>> error: ',
                    err
                );
            });
    }
};

/**
 *
 * @param {*} API
 * @param {*} msgRes
 * @param {*} userChatList
 * @param {*} setUserChatList
 */
const updateFootprintDetailList = async (API, msgRes, userChatList, setUserChatList) => {
    let footprintListDetail = [];
    if (!Utils.isEmptyObject(msgRes.footPrint) && !Utils.isEmptyArray(msgRes.footPrint.userList)) {
        let istUserChatListChange = false;
        msgRes.footPrint.userList.forEach(async userId => {
            let userFootPrint = _.find(userChatList, ['id', userId]);
            if (Utils.isEmptyObject(userFootPrint)) {
                userFootPrint = await getUserById(API, userId);
                if (Utils.isEmptyObject(userFootPrint)) {
                    userChatList.push(getUserDeletedInfor(userId));
                    istUserChatListChange = true;
                } else {
                    footprintListDetail.push(userFootPrint);
                    userChatList.push(userFootPrint);
                    istUserChatListChange = true;
                }
            } else {
                if (!userFootPrint.deleteFlag) {
                    footprintListDetail.push(userFootPrint);
                }
            }
        });
        msgRes.footprintListDetail = footprintListDetail;
        if (istUserChatListChange) {
            setUserChatList(userChatList);
        }
    }
};

/**
 * getContentChatPost
 * @param {*} chatPost
 * @param {*} userChatList
 * @param {*} isAlignLeft
 * @returns
 */
export const getContentChatPost = (chatPost, userChatList, isAlignLeft,isFromQA) => {
    let contentIncludeHtml = chatPost.content;
    contentIncludeHtml = Utils.escapeHtmlCharacters(contentIncludeHtml);

    if (!Utils.isEmptyArray(chatPost.mention)) {
        chatPost.mention.forEach(userId => {
            let displayName = '';

            if (userId === Constant.CHAT_MENTION_ALL.id) {
                displayName = Constant.CHAT_MENTION_ALL.name;
                contentIncludeHtml = contentIncludeHtml.replaceAll(
                    `@[${userId}]`,
                    `<span class="text-mention"> @${displayName} </span>`
                );
            } else {
                let userMention = userChatList.find(user => user.id === userId);
                if (!Utils.isEmptyObject(userMention)) {
                    displayName =
                        userMention.id !== Constant.CHAT_MENTION_ALL
                            ? Utils.getFullNameOfUser(Constant.LANGUAGE_TYPE.JP, userMention)
                            : userMention.name;
                    displayName = Utils.escapeHtmlCharacters(displayName);

                    contentIncludeHtml = contentIncludeHtml.replaceAll(
                        `@[${userId}]`,
                        `<span class="text-mention"> @${displayName} </span>`
                    );
                }
            }
        });
    }

    const classNameLink = isAlignLeft ? 'linkAtLeft' : 'linkAtRight';
    return Utils.replaceUrls(contentIncludeHtml, isFromQA, false, classNameLink);
};

/**
 * getContentChatPostEmail
 * @param {*} chatPost
 * @param {*} userChatList
 * @param {*} isAlignLeft
 * @returns
 */
 export const getContentChatPostEmail = (chatPost, userChatList, isAlignLeft,isFromQA, ) => {
    let contentIncludeHtml = chatPost.content;

    if (!Utils.isEmptyArray(chatPost.mention)) {
        chatPost.mention.forEach(userId => {
            let displayName = '';

            if (userId === Constant.CHAT_MENTION_ALL.id) {
                displayName = Constant.CHAT_MENTION_ALL.name;
                contentIncludeHtml = contentIncludeHtml.replaceAll(
                    `@[${userId}]`,
                    `<span class="text-mention"> @${displayName} </span>`
                );
            } else {
                let userMention = userChatList.find(user => user.id === userId);
                if (!Utils.isEmptyObject(userMention)) {
                    displayName =
                        userMention.id !== Constant.CHAT_MENTION_ALL
                            ? Utils.getFullNameOfUser(Constant.LANGUAGE_TYPE.JP, userMention)
                            : userMention.name;
                    displayName = Utils.escapeHtmlCharacters(displayName);

                    contentIncludeHtml = contentIncludeHtml.replaceAll(
                        `@[${userId}]`,
                        `<span class="text-mention"> @${displayName} </span>`
                    );
                }
            }
        });
    }
    return contentIncludeHtml
};

/**
 * getAllChatThreadId
 * @param {*} args
 * @param {*} isShowAllChatPost
 * @param {*} selectThread
 * @returns
 */
export const getAllChatThreadId = (args, isShowAllChatPost, selectThread) => {
    let threadIdList = [];
    if (isShowAllChatPost) {
        if (args.customerReferenceThread) {
            threadIdList.push(args.customerReferenceThread.id);
        }
        if (args.customerThread?.id) {
            threadIdList.push(args.customerThread.id);
        }
        if (args.internalThread?.id) {
            threadIdList.push(args.internalThread.id);
        }
        if (args.escalationThread && args.escalationThread.length > 0) {
            args.escalationThread.forEach(element => {
                threadIdList.push(element.id);
            });
        }
    } else {
        threadIdList.push(selectThread.id);
    }

    return threadIdList;
};

/**
 * handleScrollListMessage
 * @param {*} e
 * @param {*} args
 */
export const handleScrollListMessage = async (e, args, chatThreadId, projectInuseId) => {
    // console.log('handleScrollListMessage :>> ', args);
    // check display jump to bottom
    let element = e.target;
    if (element.offsetHeight + element.scrollTop >= element.scrollHeight - 100) {
        args.setIsDisplayJump(false);
    } else {
        args.setIsDisplayJump(true);
    }

    // if scroll list to top then load 30 old message
    if (e.currentTarget.scrollTop === 0) {
        if (args.lastedCountList === Constant.CHAT_PAGINATION_DEFAULT_RECORD) {
            args.setIsLoading(true);

            let chatPostAllListClone = cloneDeep(args.chatPostAllList);
            let postDetailListSorted = sortByCreatedAtAndSeqAsc(chatPostAllListClone);
            let firstPost = postDetailListSorted[0];

            let threadIdList = Utils.isEmptyString(chatThreadId)
                ? getAllChatThreadId(args, args.isShowAllChatPost, args.selectThread)
                : [chatThreadId];
            let from = args.fromMsg + Constant.CHAT_PAGINATION_DEFAULT_RECORD;
            let posts = await getChatPostListByChatThreadId(args.API, threadIdList, from, projectInuseId);

            if (!Utils.isEmptyObject(posts)) {
                let userChatListClone = cloneDeep(args.userChatList);
                if (!Utils.isEmptyArray(posts.userChatList)) {
                    posts.userChatList.forEach(user => {
                        if (Utils.findIndexInArrayById(user.id, userChatListClone) === -1) {
                            userChatListClone.push(user);
                        }
                    });
                    args.setUserChatList(userChatListClone);
                }

                args.setChatPostAllList({
                    type: Constant.ACTION_CHANGE_LIST_DATA_TYPE.CONCAT,
                    posts: posts.chatPostAllList
                });

                args.setLastedCountList(posts.chatPostAllList.length);
                args.setFromMsg(from);

                // scroll to current position
                const elementPost = document.getElementById(firstPost?.id);
                // console.log('namnhdebug scroll handleScrollListMessage')
                elementPost.scrollIntoView();
            }

            args.setIsLoading(false);
        }
    }
};

const isEmailTicketCustomerChatthread = (ticketInfo, selectThread) => {
    return (ticketInfo?.ticketType === Constant.TICKET_TYPE.EMAIL) && 
        (selectThread.threadType === Constant.THREAD_TYPE.CUSTOMER)
}

export const isDisplayReactionBtn = (ticketInfo, chatPost, selectThread, isEnableChat, isDisableLink = false) => {
    if (isDisableLink) return false;
    
    return (
        ticketInfo.liveOrArchived !== Constant.LIVE_OR_ARCHIVED.ARCHIVED &&
        chatPost.chatThreadId === selectThread.id &&
        isEnableChat && !isEmailTicketCustomerChatthread(ticketInfo, selectThread)
    );
};

export const isDisplayBtnCopyMsgId = (chatPost, ticketInfo) => {
    if (!chatPost || !Utils.isEmptyString(ticketInfo?.deletedAt)) return false;
    return true;
};

/**
 * getNewReactionByChatPost
 * @param {*} reaction
 * @param {*} emojiId
 * @param {*} userId
 * @returns
 */
export const getNewReactionByChatPost = (reaction, emojiId, userId) => {
    let reactionMsg = cloneDeep(reaction);

    if (reactionMsg.hasOwnProperty(emojiId)) {
        let listUserReaction = reactionMsg[`${emojiId}`].userId;

        if (!Utils.isEmptyArray(listUserReaction)) {
            if (listUserReaction.includes(userId)) {
                listUserReaction = listUserReaction.filter(id => id !== userId);
            } else {
                listUserReaction.push(userId);
            }
        } else {
            listUserReaction = [userId];
        }

        if (!Utils.isEmptyArray(listUserReaction)) {
            reactionMsg[`${emojiId}`] = {
                seq: reactionMsg[`${emojiId}`].seq,
                userId: listUserReaction
            };
        } else {
            delete reactionMsg[`${emojiId}`];
        }
    } else {
        reactionMsg[`${emojiId}`] = {
            seq: Date.now().toString(),
            userId: [userId]
        };
    }

    return reactionMsg;
};

/**
 * validateReaction
 * @param {*} reaction
 * @param {*} emojiId
 * @param {*} userId
 * @returns
 */
export const validateReaction = (reaction, emojiId, userId) => {
    if (Utils.isEmptyObject(reaction)) return '';
    if (reaction[emojiId]?.userId?.includes(userId)) return '';

    // check total emoji in chat post
    if (
        Object.keys(reaction).length >= Constant.MAX_EMOJI_PER_CHAT_POST &&
        !reaction.hasOwnProperty(emojiId)
    ) {
        return 'USER07MSG006';
    }

    // check total number of reaction by current user
    let totalReactionByUser = 0;
    for (let key of Object.keys(reaction)) {
        let listUserReaction = reaction[key].userId;
        if (!Utils.isEmptyArray(listUserReaction) && listUserReaction?.includes(userId)) {
            totalReactionByUser++;
        }
    }

    if (totalReactionByUser >= Constant.MAX_REACTION_BY_USER) {
        return 'USER07MSG007';
    }

    return '';
};

/**
 * generateTooltipReaction
 * @param {*} reaction
 * @param {*} userChatList
 * @returns
 */
export const generateTooltipReaction = (reaction, userChatList, currentUserDetail) => {
    let listUserReaction = reaction.userId ? reaction.userId : [];
    listUserReaction = cloneDeep(listUserReaction).reverse();

    let currentUserIndex = listUserReaction?.findIndex(item => item === currentUserDetail.id);
    if (currentUserIndex !== -1) {
        let [me] = listUserReaction.splice(currentUserIndex, 1);
        listUserReaction.unshift(me);
    }

    let listUserName = [];
    if (!Utils.isEmptyArray(listUserReaction)) {
        for (let i = 0; i < listUserReaction.length; i++) {
            if (i >= Constant.MAX_REACTION_TOOLTIP_USERNAME) break;

            let userId = listUserReaction[i];
            let userDetail = userChatList.find(user => user.id === userId);
            if (!Utils.isEmptyObject(userDetail)) {
                if (userDetail.id === currentUserDetail.id) {
                    listUserName.unshift('あなた');
                } else {
                    listUserName.push(
                        Utils.getFullNameOfUser(Constant.LANGUAGE_TYPE.JP, userDetail)
                    );
                }
            }
        }
    }

    let listUserNameString = '';
    if (!Utils.isEmptyArray(listUserName)) {
        listUserNameString = listUserName.join('、');

        if (listUserReaction.length > Constant.MAX_REACTION_TOOLTIP_USERNAME) {
            let countUserOther = listUserReaction.length - Constant.MAX_REACTION_TOOLTIP_USERNAME;
            listUserNameString = `${listUserNameString}、その他 ${countUserOther} 人が`;
        }
    }

    let tooltipValue = '';
    if (!Utils.isEmptyString(listUserNameString)) {
        tooltipValue = `${Utils.escapeHtmlCharacters(
            listUserNameString
        )} <span class="text-emoji">:${reaction?.id}:</span> に反応しました。`;
    }

    return tooltipValue;
};

export const userAccessShareLinkTicket = async (
    userId,
    ticketId,
    projectInuseId,
    affiliationOrganizationDomain,
    affiliationProject,
    withMessage
) => {
    try {
        let checkPermissionResult = await API.graphql({
            query: checkViewTicketPermission,
            variables: {
                params: {
                    userId: userId,
                    ticketId: ticketId,
                    affiliationOrganizationDomain: affiliationOrganizationDomain,
                    affiliationProject: affiliationProject,
                    projectInuseId: projectInuseId,
                    chatPostId: withMessage
                }
            }
        });
        return checkPermissionResult.data.checkViewTicketPermission;
    } catch (err) {
        console.log('err', err);
        return {
            payload: {
                isHasPermission: false,
                reason: Constant.REASON_CAN_NOT_ACCESS_TICKET.INVALID_URL
            }
        };
    }
}

export const openShareLinkTicket = async (
    API,
    ticketId,
    affiliationProject,
    affiliationOrganizationDomain,
    userId,
    projectInuseId,
    functionParams,
    withMessage
) => {
    const result = await userAccessShareLinkTicket(
        userId,
        ticketId,
        projectInuseId,
        affiliationOrganizationDomain,
        affiliationProject,
        withMessage
    );
    const payload = Utils.convertJSONDataToObject(result.payload);
    /**
     * check user permission view ticket and user permission view chat
     */
    if (!payload.isHasPermission || (
        payload.hasOwnProperty('hasChatPermission') &&
        !payload?.hasChatPermission)) {
       return handleUserNotHavePermission(payload, functionParams);
    }

    return handleUserAccessTicket(
        payload?.ticketId || ticketId,
        affiliationProject,
        payload,
        functionParams,
        projectInuseId
    );
};

export const handleUserNotHavePermission = (payload, functionParams) => {
    switch (payload.reason) {
        case Constant.REASON_CAN_NOT_ACCESS_TICKET.CORP_INACTIVE:
        case Constant.REASON_CAN_NOT_ACCESS_TICKET.INVALID_URL:
        case Constant.REASON_CAN_NOT_ACCESS_TICKET.TICKET_DELETED:
        case Constant.REASON_CAN_NOT_ACCESS_TICKET.DELETED_CONTENT: {
            if (functionParams?.setIsLoading) {
                functionParams?.setIsLoading(false);
            }
            functionParams?.setIsOpenNotFoundTicketPopup(true);
            break;
        }
        case Constant.REASON_CAN_NOT_ACCESS_TICKET.DELETED_MESSAGE: {
            functionParams?.setIsLoading && functionParams?.setIsLoading(false);
            if (functionParams?.setShowPopupSingleButtonError) {
                functionParams?.setShowPopupSingleButtonError(preState => {
                    return {
                        ...preState,
                        isShow: true,
                        message: I18n.get('MSG-CM-DELETED-MESSAGE')
                    };
                });
            }
            break;
        }
        case Constant.REASON_CAN_NOT_ACCESS_TICKET.DONT_HAVE_PERMISSION_BY_CHATPOST:
        case Constant.REASON_CAN_NOT_ACCESS_TICKET.DONT_HAVE_PERMISSION: {
            if( functionParams?.setIsLoading) functionParams?.setIsLoading(false);
            functionParams?.setIsOpenAccessDeniedPopup(true);
            break;
        }
        default: {
            if (functionParams?.setIsLoading) {
                functionParams?.setIsLoading(false);
            }
        }
    }
};

const handleUserAccessTicket = async (ticketId, affiliationProject, payload, functionParams, projectInuseId) => {
    if (payload.isEnableKnowledgeService || payload?.isEnableServicesToViewTicket) {
        let targetProjectId = payload?.targetProjectId || projectInuseId
        const targetThreadId = payload?.selectedThreadDetail?.id;
        const targetChatPostDetail = payload?.chatPostDetail; 
        await openPanelShareLinkTicket(
            { ...functionParams, openPanelType: payload?.openPanelType },
            projectInuseId,
            ticketId,
            targetProjectId,
            targetThreadId,
            targetChatPostDetail
        );
    } else {
        if( functionParams?.setIsLoading){
            functionParams?.setIsLoading(false);
        }
        functionParams.setIsOpenPopupKnowledgeOff(true)
    }
}

const openPanelShareLinkTicket = async (
    props,
    projectInuseId,
    ticketId,
    targetProjectId,
    targetThreadId,
    targetChatPostDetail
) => {
    let detailTicket = await getTicketById(props?.API, ticketId);
    if (props?.setIsLoading) {
        props?.setIsLoading(false);
    }

    await openPanelByTicketDetail(
        detailTicket,
        projectInuseId,
        props.addNewPanel,
        props,
        props.setLastUserAction,
        targetProjectId,
        targetThreadId,
        targetChatPostDetail
    );
};